import React, { useMemo, useState } from 'react'
import CustomSearch from '../../components/search/CustomSearch'
import { Button, message, Space, Spin, Table, Tooltip } from 'antd'
import Pnation from '../../components/Pagination/pagination'
import MotionIconButton from '../../components/icons/MotionIcon';
import { Link } from 'react-router-dom';
import { downloadFile, limitWords } from '../../utils/utils';
import FileTextIcon from '../../components/icons/FileTextIcon';
import RightArrowIcon from '../../components/icons/RightArrowIcon';
import fetchWithAuth from '../../utils/customFetch';
import { useSelector } from 'react-redux';
import BoldPlusIcon from '../../components/icons/BoldPlusIcon';

export default function Listing() {
    const [isLoading, setIsloading] = useState(false);
    const [allData, setAllData] = useState([])

    const comp_id = useSelector((state) => state.auth.userInfo.company_id);
    const conpanyId = localStorage.getItem("companyId");
    const [searchKeyword, setSearchKeyword] = useState({ search_keyword: '', company_id: conpanyId || comp_id });
    const basePath = conpanyId ? `/admin/company/${conpanyId}/esign` : `/admin/esign`;

    const columns = useMemo(() =>
        [{
            title: "Name",
            dataIndex: "party_name",
            elipsis: true,
            width: 100,
            render: (userName, record) => (
                <span style={{ fontWeight: !record.is_read ? "normal" : "bold" }}>
                    {userName}
                </span>
            ),
        },
        {
            title: <Tooltip className="whitespace-nowrap" title="Description">Description</Tooltip>,
            dataIndex: "description",
            elipsis: true,
            width: 200,
            render: (text, record) => (
                <Tooltip title={text}>
                    <div
                        style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            fontWeight: !record.is_read ? "normal" : "bold",
                        }}
                    >
                        {limitWords(text, 6)}
                    </div>
                </Tooltip>
            ),
        },
        {
            title: <Tooltip className="whitespace-nowrap" title="Execution File">Document Type</Tooltip>,
            dataIndex: "name_of_client",
            elipsis: true,
            width: 200,
            render: (text, record) => (
                record.document_type
            ),
        },
        {
            title: "Execution File",
            elipsis: true,
            width: 150,
            dataIndex: "agreement",
            render: (text, record) => (
                <>
                    <Button
                        onClick={() => {
                            if (!record.execution_file) {
                                message.error('File not exist .');
                                return false
                            }
                            downloadFile(record.execution_file)
                        }}
                        type="submit"
                    >
                        <FileTextIcon />
                    </Button>
                </>
            ),
        },
        {
            title: "Executed File",
            elipsis: true,
            width: 150,
            dataIndex: "agreement",
            render: (text, record) => (
                <>
                    <Button
                        onClick={() => {
                            if (!record.executed_file) {
                                message.error('File not exist .');
                                return false
                            }
                            downloadFile(record.executed_file)
                        }}
                        type="submit"
                    >
                        <FileTextIcon />
                    </Button>
                </>
            ),
        },
        {
            title: "View details",
            elipsis: true,
            width: 150,
            dataIndex: "first_name",
            key: "first_name",
            render: (text, record) => (
                <Link
                    to={`${basePath}/details/${record.id}?referrer=dashboard&tab=details`}
                >
                    <button type="submit">  <RightArrowIcon /> </button>
                </Link>
            ),
        }], [])

    const onPeding = (val) => {
        setIsloading(val)
    }
    const getData = (data) => {
        setAllData(data)
    }
    const handleSearch = (value) => {
        setSearchKeyword((val) => {
            val.search_keyword = value;
            return { ...val }
        })
    };
    return (
        <div className="">
            {/* Header: Title + Create Button */}
            <div className="mb-4 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                <div className='flex items-center justify-between w-full gap-4 md:w-auto'>

                <h1 className="font-semibold text-[15px] pt-[1%] dark:text-white">E-sign</h1>
                <div className=" text-black flex justify-right">
                        <CustomSearch onSearch={handleSearch} />
                </div>
                </div>
                <Link to={`${basePath}/create_esign`}>
                    <MotionIconButton tooltip="Add E-sign" icon={<BoldPlusIcon />} />
                </Link>
            </div>

            <div className="border border-gray-300 rounded-md overflow-x-auto">
                <Spin spinning={isLoading} tip="Loading...">
                    <Table
                        columns={columns}
                        dataSource={allData}
                        scroll={{ x: 1000, y: 400 }}
                        tableLayout="fixed"
                        pagination={false}
                        size="small"
                        className='text-[12px] [&_.ant-table-cell]:p-1 [&_.ant-table-cell]:text-[12px]'
                    />
                </Spin>
            </div>

            {/* Pagination */}
            <div className="mt-4">
                <Pnation
                    isCustomFetch={false}
                    onPeding={onPeding}
                    onCngPage={getData}
                    url="/agreements/list/"
                    plod={searchKeyword}
                    itmeName="E-sign Documents"
                />
            </div>
        </div>

    )
}
